
// ROUTES
require('modules/social-stream/routes/social-stream');

// CONTROLLERS
require('modules/social-stream/controllers/social-stream');
require('modules/social-stream/controllers/list');

// SERVICES
require('modules/social-stream/services/social-stream');
require('modules/social-stream/services/list');
require('modules/social-stream/services/delete');


angular.module('unica_social_stream', [

	'angularGrid',

	// ROUTES
	'unica_social_stream.social_stream_routes',

	// CONTROLLERS
	'unica_social_stream.social_stream_controllers',

	// SERVICES
	'unica_social_stream.social_stream_services'

]);